import { Component, OnInit, ViewChild } from '@angular/core';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { Navigator } from "src/app/components/menu/navigator";
import { EventsService } from 'src/app/services/event/event.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
  selector: 'app-past-bonuses',
  templateUrl: './past-bonuses.component.html',
  styleUrls: ['./past-bonuses.component.scss'],
})
export class PastBonusesComponent implements OnInit {
  error = null;

  public bonusObj: any[] = [];
  private bonusArray: any[] = new Array;

  searchDisabled: boolean = false;
  public showTable: boolean = false;
  public showNoResults: boolean = false;

  public toDate;
  public fromDate;
  public todayDate;

  public startDate: any;
  dateRange: number;
 
  constructor(
    private successMessageService: SuccessMessageService,
    public timeService: TimeService,
    private bonusService: BonusService,
    private navigator: Navigator,
    private events: EventsService,
    public config: ConfigService,
  ) { }

  ngOnInit() {
    this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
  }
  
  calendarUpdate(event) {
    this.toDate = event.toDate;
    this.fromDate = event.fromDate;
    this.searchDisabled = event.search;
    this.successMessageService.clearMessage();
  }


  ionViewDidEnter() {
    this.successMessageService.clearMessage();

    let today = new Date();
    let date = new Date();
    this.todayDate = today;

    this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
    this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today)); //setting today date fallback and initial value for 'To' data passed to webservices
    this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
  }

  onSearch() {
    this.searchDisabled = true;
    this.bonusService.callGetCustomerCasinoBonusesHistory(this.fromDate, this.toDate).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          //this.bonusObj = response.payload.response;
          this.bonusArray = response.payload.response;
          if (this.bonusArray.length > 0) {
            let expiredBonusArray = this.bonusArray.filter(x => x.status == 'EXPIRED')
            this.events.publish("event:Totalbonus", { expiredBonus: expiredBonusArray, page: 'Casino Bonus History' });
          }

          this.bonusArray.forEach(element => {
            let shortenedDisplayName: string = element.displayName;
            if (shortenedDisplayName.length > 9 && shortenedDisplayName.substr(0, 12).indexOf(" ") == -1) {
              shortenedDisplayName = shortenedDisplayName.substring(0, 7) + "...";
              element.shortenedDisplayName = shortenedDisplayName;
            }
            else {
              element.shortenedDisplayName = element.displayName;
            }
          });

          if (this.bonusArray.length > 0) {
            this.showTable = true;
            this.showNoResults = false;
          }
          else {
            this.showNoResults = true;
            this.showTable = false;
          }
        }
      },
      (error) => {
        this.showTable = false;
        this.error = error;
      }
    );
  }

  onTotalBonusClicked(bonus: any) {
    //bonus["currentBonus"] = bonus["originalBonus"];
    this.navigator.navigateTo("BonusDetailsComponent", { multipleModals: true }, { bonus: bonus });
    return false;
  }
}
